import toast from 'react-hot-toast';

export const toastedSuccess = (msg) => {
  toast.success(msg, {
    className: 'custom-toast success',
  });
};

export const toastedError = (msg) => {
  toast.error(msg, {
    className: 'custom-toast error',
  });
};

export const toastedInfo = (msg) => {
  toast(msg, {
    className: 'custom-toast info',
  });
};